// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-tile-group[data-v-c76968ba] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.radio-tile-group button[data-v-c76968ba] {\n  width: 40%;\n  margin-top: 20px;\n  margin-right: 5%;\n}", ""]);
// Exports
module.exports = exports;
